import styled from 'styled-components';
import appLogo192 from '../../assets/icons/imgs/app_logo192.png';
import enjoyAvatars from '../../assets/icons/imgs/enjoy_avatars.png';
import enjoyFiveAvatars from '../../assets/icons/imgs/enjoy_fiveavatars.png';
import enjoyHandle from '../../assets/icons/imgs/enjoy_handle.png';
import enjoyLogo from '../../assets/icons/imgs/enjoy_logo.png';
import enjoyScore from '../../assets/icons/imgs/enjoy_score.png';
import enjoyTopBack from '../../assets/icons/imgs/enjoy_topback.png';
import enjoyVoteA from '../../assets/icons/imgs/enjoy_vs.png';

export const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, 
    rgba(254, 243, 226, 1) 0%, 
    rgba(232, 252, 234, 1) 33%, 
    rgba(255, 255, 255, 1) 100%
  );
  padding: 0;
  font-family: 'Montserrat', 'Arial', sans-serif;
  position: relative;
  overflow-x: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  backdrop-filter: blur(10px);
  // box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  background: linear-gradient(180deg, rgba(252, 151, 0, 0.11) 0%, rgba(252, 151, 0, 0.00) 100%);
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .logo-icon {
    width: 40px;
    height: 40px;
    background-image: url(${appLogo192});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 8px;
  }

  span {
    color: #2B2928;
    text-align: center;
    font-family: "SF UI Text";
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const PlayButton = styled.button`
  border-radius: 50px;
  border: 1px solid #FCFCFC;
  background: linear-gradient(143deg, #FBC171 -0.68%, #7F3A15 100%);
  box-shadow: 0 -2px 4px -5px rgba(255, 255, 255, 0.50) inset;
  color: white;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
`;

export const VoteSection = styled.div`
  text-align: center;
  padding: 100px 24px 0px 24px;
  position: relative;
  z-index: 5;
`;

export const VoteTitle = styled.h1`
  font-family: 'SFUIText-HeavyItalic', 'SF UI Text', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 25px;
  font-weight: 900;
  font-style: italic;
  color: black;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const VoteSubtitle = styled.p`
  font-size: 16px;
  color: black;
  margin-bottom: 40px;
  font-weight: 400;
`;

export const VoteCards = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 32px;
  padding: 0 20px;
  position: relative;

  /* PC端间距 */
  @media (min-width: 769px) {
    gap: 80px;
  }
`;

export const VoteCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  position: relative;
`;

export const VoteCardVS = styled.div`
  position: absolute;
  left: 50%;
  top: ${props => props.hasVoted ? '70%' : '50%'};
  transform: translate(-50%, calc(-50% - 30px));
  width: 60px;
  height: 60px;
  background-image: url(${enjoyVoteA});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 20;
`;

export const VoteCard = styled.div`
  /* 移动端默认样式 */
  width: 140px;
  height: 180px;
  border: none;
  border-radius: 20px;
  background: ${props => props.selected ? 'rgba(255, 147, 147, 1)' : 'white'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: ${props => props.selected ? '0 8px 32px rgba(255, 147, 147, 0.3)' : '0 4px 16px rgba(0, 0, 0, 0.1)'};

  /* PC端样式 */
  @media (min-width: 769px) {
    width: 162px;
    height: 202px;
    flex-shrink: 0;
  }

  &:hover {
    transform: ${props => props.disabled ? 'none' : 'translateY(-4px) scale(1.02)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 12px 40px rgba(255, 255, 255, 0.3)'};
  }
`;

export const VoteCardImage = styled.div`
  width: calc(100% - 22px);
  height: calc(100% - 28px);
  border-radius: 20px;
  background-color: rgba(43, 41, 40, 1);
  background-image: url('${props => props.imageUrl || ''}');
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  margin: 14px 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;

  .avatar {
    font-size: 36px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
`;

export const VoteCardHeart = styled.div`
  position: absolute;
  bottom: 10px;
  right: 14px;
  color: #2B2928;
  font-family: "SF UI Text";
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
`;

export const VoteCardLabel = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.hasVoted ? (props.selected ? 'rgba(251, 204, 2, 1)' : 'rgba(223, 223, 223, 1)') : 'rgba(251, 204, 2, 1)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: white;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
`;

export const VoteButton = styled.button`
  border-radius: 24px;
  border-top: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 4px solid #000;
  border-left: 1px solid #000;
  background: #FFF;
  
  display: flex;
  width: 141px;
  height: 50px;
  padding: 16px 26px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  
  font-size: 16px;
  font-weight: 600;
  color: black;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const VoteProgress = styled.div`
  width: 240px;
  height: 16px;
  background: rgba(219, 219, 219, 1);
  border-radius: 8px;
  overflow: hidden;
  backdrop-filter: blur(10px);
`;

export const VoteProgressBar = styled.div`
  height: 100%;
  width: ${props => props.width}%;
  background: rgba(251, 204, 2, 1);
  border-radius: 8px;
  transition: width 0.5s ease;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.3);
`;
export const EnjoySection = styled.div`
  position: relative;
  text-align: center;
  padding: 0px 24px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  margin: 0;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

export const EnjoyTitle = styled.div`
  width: 112.785px;
  height: 43.538px;
  aspect-ratio: 112.78/43.54;
  background-image: url(${enjoyLogo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin: 28px auto 14px auto;
  display: block;
`;

export const EnjoySubtitle = styled.p`
  color: #000;
  text-align: center;
  font-family: Hind;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  margin-bottom: 12px;
`;

export const EnjoyImage = styled.div`
  display: flex;
  width: 457.2px;
  height: 420.651px;
  padding: 9px;
  align-items: flex-start;
  gap: 9px;
  flex-shrink: 0;
  background-image: url(${enjoyHandle});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right center;
  margin: 0 auto;
`;

export const StatsContainer = styled.div`
  position: absolute;
  bottom: -58px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 400px;
  padding: 16px 24px;
  z-index: 10;
`;

export const StatsImage = styled.div`
  background-image: url(${enjoyFiveAvatars});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 40px;
  margin-bottom: 8px;
`;

export const StatsScore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  background-image: url(${enjoyScore});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 58px;
`;

export const StatsText = styled.div`
  color: #000;
  font-family: "SF UI Text";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ResidentsSection = styled.div`
  text-align: center;
  padding: 40px 0px 0px 0px;
  // backdrop-filter: blur(10px);
  margin: 0 24px 40px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ResidentsTitle = styled.h2`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;
  font-size: 24px;
  font-weight: 700;
  color: rgba(244, 135, 35, 1);
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ResidentsSubtitle = styled.p`
  align-self: stretch;
  color: #000;
  text-align: center;
  font-family: Hind;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
  margin-bottom: px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  @media (max-width: 480px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const ResidentsAvatars = styled.div`
  background-image: url(${enjoyAvatars});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: auto;
  height: 271px;
  margin: 0 auto;
`;

export const Avatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const VenuesSection = styled.div`
  text-align: center;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  margin: 0px 24px 24px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const VenuesTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin-bottom: 0px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const VenuesSubtitle = styled.p`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0px;
  font-weight: 400;
`;

export const VenuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 100px);
  gap: 16px;
  margin: 0 auto;
  justify-content: center;
  max-width: calc(6 * 100px + 5 * 16px); /* 6个item + 5个gap */

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    max-width: 100%;
    padding: 0 16px;
  }
`;

export const VenueItem = styled.div`
  width: 100px;
  height: 100px;
  background-image: url(${props => props.imageUrl});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.3s ease;

  @media (max-width: 768px) {
    width: 100%;
    height: 0;
    padding-bottom: 100%; /* 保持正方形比例 */
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

export const Copyright = styled.div`
  text-align: center;
  color: #202020;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 0px 24px 20px;
`;

export const BottomImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(1588 / 780 * 100vw);
  background-image: url(${enjoyTopBack});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  padding: 0;
  z-index: 1;
  opacity: 0.9;

  /* PC端固定高度 */
  @media (min-width: 769px) {
    height: 780px;
  }
`;

// 弹框相关样式
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(5px);

`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 100vw;
  max-height: 100vh;
  background: white;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  min-width: 300px;
  /* 移除固定的min-height，让内容自适应 */
`;

export const ModalImage = styled.div`
  background-image: url(${props => props.imageUrl || ''});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: black;
  
  /* PC端：高度撑满全屏幕，宽度按图片比例自适应 */
  @media (min-width: 768px) {
    width: auto;
    height: 100vh;
    min-width: 50vw;
    max-width: 90vw;
  }
  
  /* 移动端：宽度撑满全屏幕，高度按图片比例自适应 */
  @media (max-width: 767px) {
    width: 100vw;
    height: auto;
    min-height: 50vh;
    max-height: 80vh;
  }
  
  .avatar {
    font-size: 80px;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 75px;
  right: 20px;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  background-image: url(${props => props.closeIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 3000;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    background-image: url(${props => props.closeIcon});
    transform: scale(1.1);
  }
`;

// 模态框底部Logo
export const ModalBottomLogo = styled.div`
  position: absolute;
  bottom: 36px;
  right: 28px;
  background-image: url(${props => props.logoImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 108px;
  height: 90px;
`;

// 模态框AI生成标识
export const ModalAILabel = styled.div`
  position: absolute;
  bottom: 36px;
  left: 16px;
  color: var(--Colour-80, rgba(255, 255, 255, 0.80));
  text-align: center;
  text-shadow: 1px 0 2px rgba(0, 0, 0, 0.28);
  font-family: Hind;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`;

// 统一的投票结果区域
export const VoteResultSection = styled.div`
  margin-top: 30px;
  text-align: center;
`;

export const VoteResultTitle = styled.div`
  color: var(--Colour-800, #2B2928);
  text-align: center;
  font-family: "SF UI Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 12px;
`;

export const VoteResultProgress = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const VoteResultPercentage = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #FC9700;
`;

export const VoteResultProgressBar = styled.div`
  width: 200px;
  height: 8px;
  background-color: #E5E5E5;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${props => props.percentage || 0}%;
    background: linear-gradient(90deg, #FC9700 0%, #FFB84D 100%);
    border-radius: 4px;
    transition: width 0.3s ease;
  }
`;

// 投票成功Toast组件
export const VoteToast = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  
  display: flex;
  width: 247px;
  padding: 32px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  
  border-radius: 20px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 100%), #EFEFEF;
  background-blend-mode: plus-lighter, darken;
  box-shadow: 1px 1px 0 -0.5px #333 inset, -1px -1px 0 -0.5px #262626 inset, 1px 1px 0.5px -1px #FFF inset, -1px -1px 0.5px -1px #FFF inset, 0 0 3px 0 rgba(255, 255, 255, 0.50) inset, 0 0 11px 0 #F2F2F2 inset;
  backdrop-filter: blur(23px);
  
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-align: center;
  animation: toastFadeIn 0.3s ease-out;
  
  @keyframes toastFadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.8);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
`;